import React from "react";
import styled from "styled-components";

import { LoginWrapper, LoginBtn, LoginSliderWrapper, SliderContentsWrapper, LoginImg, LoginComment, BtnWrapper } from "./LoginStyle";
import Slider from "react-slick";
import "./slick.css"; 
import "./slick-theme.css";
import typoLogo from '../../../assets/icons/typoLogo.svg';
import florist from '../../../assets/images/login/florist-cuate.svg'
import comment from '../../../assets/images/login/loginComment.svg'
import search from '../../../assets/images/login/searchEngines.svg'
import location from '../../../assets/images/login/locationTracking.svg'
import florists from '../../../assets/images/login/loginFlorists.svg'

import {KAKAO_AUTH_URL} from './common/OAuth';

function Login() {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToshow: 1,
        slidesToScroll: 1,
        arrows: false,
    }
    
    return (
        <LoginWrapper>
            <LoginSliderWrapper>
                <Slider {...settings} style={{height: '100%'}}>
                    <div>
                        <SliderContentsWrapper>
                            <ContentContainer>
                                <img src={ typoLogo } style={{height: '7.5vh', display: 'block', margin: '0 auto', padding: '2vh 0 1.5vh'}}/>
                                <div style={{textAlign: 'center'}}>
                                    꽃 정보를 얻는 쉽고 빠른길
                                </div>
                            </ContentContainer>
                            <LoginImg src={ florist } style={{width: '34vh'}}/>
                        </SliderContentsWrapper>
                    </div>
                    <div>
                        <SliderContentsWrapper>
                            <Title>
                                원하는 꽃을 검색하고<br />
                                꽃 시장 시세, AI가 예측한 가격,<br />
                                구매 가능성을 확인해 보세요
                            </Title>
                            <LoginImg src={ search }/>
                        </SliderContentsWrapper>
                    </div>
                    <div>
                        <SliderContentsWrapper>
                            <Title>
                                도매상이 판매하는 품목, 위치를 파악하고<br />
                                전화와 채팅으로 직접 문의해 보세요
                            </Title>
                            <LoginImg src={ location } style={{width: '30vh'}}/>
                        </SliderContentsWrapper>
                    </div>
                    <div>
                        <SliderContentsWrapper>
                            <Title>
                                플로리스트끼리 업계 이야기를 나누며<br />
                                유용한 정보들은 공유해 보세요
                            </Title>
                            <LoginImg src={ florists } style={{width: '38vh'}}/>
                        </SliderContentsWrapper>
                    </div>
                </Slider>
            </LoginSliderWrapper>
            <BtnWrapper>
            <LoginComment src={ comment }/>
            <a href={KAKAO_AUTH_URL}>
                <LoginBtn> 카카오로 3초만에 시작하기
                </LoginBtn>
            </a>
            </BtnWrapper>
        </LoginWrapper>
    )
}

export default Login;

const ContentContainer = styled.div`
  height: 15vh;
`;

const Title = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1vh;
  text-align: center;
`;


 
